define('components/ArchivePicker',[
    "jquery",
    "logging"
], function ($, logging) {
    var _ModuleName = "Archive Picker";

    function ArchivePicker(scope, config) {
        "use strict";

        var yearDropdown = $('[name="archive-year"]');
        var monthDropdown = $('[name="archive-month"]');
        var archiveUrl;

        yearDropdown.change(function() {
            var monthSelection = "";

            if (monthDropdown.val() != "month") {
                monthSelection = "/" + monthDropdown.val();
            }

            // Display archives for the selected year if populated
            if (yearDropdown.val() != "year") {
                archiveUrl = config.siteUrl + "/" + yearDropdown.val() + monthSelection;
            } else {
                archiveUrl = config.siteUrl + "/archive-index/";
            }

            $(location).attr('href', archiveUrl);
        });

        monthDropdown.change(function() {           
            // Display archives for the selected month only if year is populated
            if (yearDropdown.val() != "year") {
                archiveUrl = config.siteUrl + "/" + yearDropdown.val();

                // Get the selected month
                if (monthDropdown.val() != "month") {
                    archiveUrl = config.siteUrl + "/" + yearDropdown.val() + "/" + monthDropdown.val();
                }

                // Reset everything
                if (yearDropdown.val() == "year" && monthDropdown.val() == "month") {
                    archiveUrl = config.siteUrl + "/archive-index/";
                }

                $(location).attr('href', archiveUrl);
            }
        });        

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new ArchivePicker(args.scope, args.Config);
        }
    }
});
